import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  array,
} from 'libs/form';

export const MAX_FILES = 1;

export interface SigningContractFormType {
  fileIds: string[];
}

export const getSchema = (): ObjectSchema<SigningContractFormType> =>
  object({
    fileIds: array().of(string().required()).required().min(1).max(MAX_FILES),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<SigningContractFormType>();

export type FormErrors = FormErrorsBase<SigningContractFormType>;
